import * as httpHelper from '../../utils/http-helper';

function buscarAnos(cpf: string) {
  const headers = httpHelper.defaultHeaders();

  return httpHelper.get(
    headers,
    `DemonstrativoIRAnos_V2?_cpf=${cpf}`
  );
}

function buscarDemonstrativo(cpf: string, ano: string) {
  const headers = httpHelper.defaultHeaders();

  return httpHelper.get(
    headers,
    `DemonstrativoIR_V2?_cpf=${cpf}&_ano=${ano}`
  );
}

const impostoRendaService = {
  buscarAnos,
  buscarDemonstrativo,
}

export default impostoRendaService;
